import { render, staticRenderFns } from "./ServiceWarningBox.vue?vue&type=template&id=7f8f8ab1&scoped=true"
import script from "./ServiceWarningBox.vue?vue&type=script&lang=js"
export * from "./ServiceWarningBox.vue?vue&type=script&lang=js"
import style0 from "./ServiceWarningBox.vue?vue&type=style&index=0&id=7f8f8ab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f8ab1",
  null
  
)

export default component.exports